// extracted by mini-css-extract-plugin
export default {"Nothing_Container":"NotFound_Nothing_Container__OGyIV","NothingSVG":"NotFound_NothingSVG__2HIw-","Nothing_Text":"NotFound_Nothing_Text__Qb6IR"};